import { connect } from 'react-redux';

import { IState } from '../../store';
import { BannerLegalSupport, IBannerLegalSupportProps } from './index';
import { getParent } from '../../utils/offer_helpers';
import { Dispatch } from 'redux';
import { trackInViewPort } from '../../actions/requestDemand';
import { EDemandBlockTypes } from '../../constants/requestDemand';

export const mapStateToProps = (state: IState): Partial<IBannerLegalSupportProps> => {
  return {
    offer: state.offerData.offer,
    parent: getParent(state.offerData),
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<IState>) => ({
  onShownInViewPort(visible: boolean) {
    dispatch(trackInViewPort(EDemandBlockTypes.CHECK_CLEAN, visible));
  },
});

export const BannerLegalSupportContainer = connect(mapStateToProps, mapDispatchToProps)(BannerLegalSupport);
